import PropTypes from 'prop-types';
import { Layout, Loading } from '@folio/stripes/components';
import { renderDisplayComponent } from './DisplayMethodRegistry';
import ErrorMessage from '../../../common/errorMessage/ErrorMessage';
import EmptyData from '../../../common/emptyData/EmptyData';

function GenericResultsDisplay({
  resultSet,
  error,
  isLoading,
  displayMethod,
  reportType,
  onDrillDown,
  exportOptions,
  printOptions,
  query,
  setQuery,
  chartOptions,
  formatting,
  groupByDimension,
  pivotRowDimension,
  pivotColDimension,
}) {
  // Handle loading state
  if (isLoading) {
    return (
      <Layout
        className="centered full"
        style={{ maxWidth: '15rem', height: '8rem' }}
      >
        &nbsp;
        <Loading size="xlarge" />
      </Layout>
    );
  }

  // Handle error state
  if (error && !isLoading) {
    return <ErrorMessage errorMessage={error.toString()} />;
  }

  // Handle empty query
  if (!query || query === '') {
    return <EmptyData />;
  }

  // Handle no results
  if (!resultSet || !resultSet.loadResponses?.length) {
    return <EmptyData />;
  }

  // Render results using new display registry
  return renderDisplayComponent(displayMethod, {
    resultSet,
    reportType,
    onDrillDown,
    printOptions,
    exportOptions,
    query,
    setQuery,
    chartOptions,
    formatting,
    groupByDimension,
    pivotRowDimension,
    pivotColDimension,
    fieldAliasMap: (typeof query === 'object' && query?.fieldAliasMap) || {},
    hiddenFields: [
      ...(reportType === 'productivity'
        ? ['cataloging_productivity_view_instance_created_by']
        : []),
    ],
    linkHiddenFields: [],
  });
}

GenericResultsDisplay.propTypes = {
  resultSet: PropTypes.object,
  error: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  displayMethod: PropTypes.string.isRequired,
  reportType: PropTypes.string,
  onDrillDown: PropTypes.func,
  exportOptions: PropTypes.shape({
    excel: PropTypes.bool,
    pdf: PropTypes.bool,
  }),
  printOptions: PropTypes.shape({
    componentRef: PropTypes.object,
    targetRef: PropTypes.object,
    isShowPrintWindow: PropTypes.bool,
    currentReport: PropTypes.object,
    onAfterPrint: PropTypes.func,
  }),
  query: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  setQuery: PropTypes.func,
  chartOptions: PropTypes.object,
  formatting: PropTypes.object,
  groupByDimension: PropTypes.string,
  pivotRowDimension: PropTypes.string,
  pivotColDimension: PropTypes.string,
};

GenericResultsDisplay.defaultProps = {
  exportOptions: { excel: true, pdf: true },
  printOptions: {},
};

export default GenericResultsDisplay;
